import { useEffect, useState } from 'react';

import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
// eslint-disable-next-line import/no-unresolved
import { DragEndEvent } from '@dnd-kit/core/dist/types';
import { arrayMove, sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { append, remove } from 'ramda';

import { WysiwygData } from 'components/shared/Wysiwyg/Wysiwyg.types';
import { IListBlockData } from 'detailsv2/__blocks';

import { useBlockContext } from '../../Block/context';
import { IListBlockItemData } from './Item/types';

export function useListBlockItem() {
  const { readonly, block: blockData, onUpdate } = useBlockContext();
  const { items } = blockData.data as IListBlockData;
  const [itemsDndIds, setItemsDndIds] = useState<string[]>([]);

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const handleDeleteItem = (index: string) => {
    const newObject = {
      ...blockData,
      data: {
        items: remove(Number(index), 1, items),
      },
    };

    // @ts-ignore
    onUpdate?.(newObject);
  };

  const handleAddItem = () => {
    const wysiwygData: WysiwygData = {
      text: '',
    };
    const newItem = {
      desc: wysiwygData,
    } as IListBlockItemData;
    const newObject = {
      ...blockData,
      data: {
        // @ts-ignore
        items: append(newItem, items),
      },
    };

    // @ts-ignore
    onUpdate?.(newObject);
  };

  const handleChangeItem = (index: string, data: IListBlockItemData) => {
    const newItems = [...items];
    newItems.splice(Number(index), 1, data);
    const newObject = {
      ...blockData,
      data: {
        items: newItems,
      },
    };

    // @ts-ignore
    onUpdate?.(newObject);
  };

  const handleSortItems = (itemIds: string[]) => {
    const newItems = [...itemIds.map((id) => items[Number(id)])];

    const newObject = {
      ...blockData,
      data: {
        items: newItems,
      },
    };

    // @ts-ignore
    onUpdate?.(newObject);
  };

  function handleDragEnd(event: DragEndEvent) {
    document.body.classList.remove('dragging');
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = itemsDndIds.indexOf(active?.id as string);
      const newIndex = itemsDndIds.indexOf(over?.id as string);
      const newItemsDndIds = arrayMove(itemsDndIds, oldIndex, newIndex);
      setItemsDndIds(newItemsDndIds);
      return handleSortItems(newItemsDndIds);
    }
  }

  useEffect(() => {
    setItemsDndIds(items.map((_, i: number) => String(i)));
  }, [items]);

  return {
    items,
    handleDeleteItem,
    handleChangeItem,
    handleAddItem,
    sensors,
    handleDragEnd,
    itemsDndIds,
    readonly,
  };
}
